// src/components/Footer.js
import React from "react";

export default function Footer() {
  return (
    <footer className="mt-0 border-t border-white/5">
      <div className="mx-auto max-w-6xl px-4 py-10 text-center text-sm text-text/70">
        {/* Navbar links above social links */}
        <div className="flex justify-center gap-3 mb-4">
          <a href="/about" className="hover:text-white">
            About
          </a>
          <span>·</span>
          <a href="/experience" className="hover:text-white">
            Experience
          </a>
          <span>·</span>
          <a href="/projects" className="hover:text-white">
            Projects
          </a>
          <span>·</span>
          <a href="/contact" className="hover:text-white">
            Contact
          </a>
        </div>

        {/* Social links below navbar links */}
        <div className="flex justify-center gap-5 mb-4">
          <a
            className="hover:text-white"
            href="https://github.com/ycorcos1"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a
            className="hover:text-white"
            href="https://linkedin.com/in/yahav-corcos"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
        </div>
        <p>
          © {new Date().getFullYear()} yahavcorcos.com · Designed by{" "}
          <span className="text-white">Yahav Corcos</span>
        </p>
      </div>
    </footer>
  );
}
